import { Box, Breadcrumbs, Typography } from "@mui/material";
import ChevronRightRounded from "@mui/icons-material/ChevronRightRounded";
import HomeRounded from "@mui/icons-material/HomeRounded";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../routes";
import useUser from "../../providers/user/user_provider";
import { purple, black } from "../../theme/colors";

function humanize(segment: string): string {
  return segment
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/[-_]+/g, " ")
    .replace(/^./, (c) => c.toUpperCase());
}

export default function Breadcrumb() {
  const { userPermissions } = useUser();
  const { pathname } = useLocation();
  const paths = pathname.split("/").filter((path) => path);
  const isReportsHome = pathname === "/reports";

  function getByTitle(path: string): string | null {
    return routes.find((route) => route.path == path)?.title || null;
  }

  return (
    <Box>
      <Breadcrumbs
        separator={<ChevronRightRounded sx={{ fontSize: 16, color: "#D8CBD8" }} />}
        sx={{ whiteSpace: "nowrap" }}
      >
        {userPermissions?.isPlatformOrg && (
          <Typography
            component={Link}
            to="/reports"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              fontWeight: 700,
              textDecoration: "none",
              color: isReportsHome ? black : purple,
              pointerEvents: isReportsHome ? "none" : "auto",
              "&:hover": isReportsHome ? undefined : { textDecoration: "underline" },
            }}
          >
            <HomeRounded sx={{ fontSize: 16 }} />
            Reports
          </Typography>
        )}
        {!isReportsHome &&
          paths?.map((path, index) => {
            let constructPath = "/" + paths.slice(0, index + 1).join("/");
            let title = getByTitle(constructPath);
            let isEndPath: boolean = paths.length - 1 == index;
            let isLink = !isEndPath && !!title;

            return (
              <Typography
                key={constructPath}
                component={isLink ? Link : "span"}
                to={isLink ? constructPath : undefined}
                sx={{
                  textTransform: "capitalize",
                  fontWeight: 700,
                  textDecoration: "none",
                  color: isEndPath ? black : purple,
                  "&:hover": isLink ? { textDecoration: "underline" } : undefined,
                }}
              >
                {title || humanize(path)}
              </Typography>
            );
          })}
      </Breadcrumbs>
    </Box>
  );
}
